import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-whole-number-input',
  templateUrl: './whole-number-input.component.html',
  styleUrls: ['./whole-number-input.component.scss']
})
export class WholeNumberInputComponent {
  @Input() value: string = '';
  @Input() showDollarSign: boolean = false;
  @Output() valueChange = new EventEmitter<string>();
  @Input() placeholder: string = '0';
  showError: boolean = false;

  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const val = input.value;
    const isValid = /^\d*$/.test(val);
    if (isValid) {
      this.valueChange.emit(val);
      this.showError = false;
    } else {
      this.showError = true;
      const cleaned = val.replace(/\D+/g, '');
      input.value = cleaned;
      this.valueChange.emit(cleaned);
    }
  }

  onKeyPress(event: KeyboardEvent) {
    let code;
    if (typeof event.which === 'number' && event.which !== 0) {
      code = event.which;
    } else {
      code = event.keyCode;
    }

    if (code < 48 || code > 57) {
      event.preventDefault();
      this.showError = true;
    }
  }

  onPaste(event: ClipboardEvent) {
    let paste = '';
    if (event.clipboardData && typeof event.clipboardData.getData === 'function') {
      paste = event.clipboardData.getData('text');
    }
    if (!/^\d+$/.test(paste)) {
      event.preventDefault();
      this.showError = true;
    }
  }
}
